import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CreatePayee from "./CreatePayee";
import { fetchUserGroups } from 'Api';
import { ErrorPage } from 'components';
import { getTimeflowUnifiConfig } from "./CreatePayee.api";

const CreatePayeeAccessWrapper = ({ setLoading }) => {
  const [authorized, setAuthorized] = useState(null);
  const [redirectUri, setRedirectUri] = useState(null);
  const { recordId } = useParams();

  useEffect(() => {
    const checkAccess = async () => {
      setLoading(true);
      const config = await getTimeflowUnifiConfig();
      const redirectUri = `${config?.data?.redirectUri}${recordId}`;
      const allowed = await isUserInTimeflowGroup(config);
      setAuthorized(allowed);
      setRedirectUri(redirectUri);
      setLoading(false);
    };
    checkAccess();
  }, [recordId]);

  const isUserInTimeflowGroup = async (config) => {
    if (config?.data?.enableGroupAccessCheck === true) {
      const groups = await fetchUserGroups();
      return groups.some(g => g.id === config?.data?.groupId);
    }
    return true;
  };

  if (authorized === null) {
    return <div>Loading...</div>;
  }

  if (authorized === false) {
    return <ErrorPage message="401 - You are not authorized to view this page." />;
  }
  return <CreatePayee setLoading={setLoading} recordId={recordId} redirectUri={redirectUri} />;
};

export default CreatePayeeAccessWrapper;
